import eyeIcon from './../Assets/icons/eye 1.svg'
import editIcon from './../Assets/icons/Un-Checkbox.svg'

export const TABLE_HEADERS = [
   // "Sr No.",
    "Product",
    "Sub Product",    "Make",
    "Model",
    "Variant",
    "Fuel",
    "Accessory",
    "Purchase Price",
   
    "Action"
  ];
  
  export const TABLE_DATA = [
    { srno: 1, name: "-", product:"lorem ipsum", variant:"car", sub_product: "Active", make:"Honda",model:"Activa6G",variant:"DLX",fuel_type:"Petrol", serial_no:"123" ,price:"10000",purchase_price:"1234", selling_price: "12345", actions: "Edit/Delete" },
    { srno: 2, name: "-", product:"lorem ipsum", variant:"car", sub_product: "Inactive",make:"Honda",model:"Activa6G",variant:"DLX",fuel_type:"Petrol",serial_no:"123", purchase_price:"1234", selling_price: "12345" , actions: "Edit/Delete" },
    { srno: 3, name: "-", product:"lorem ipsum", variant:"car", sub_product: "Active",make:"Honda",model:"Activa6G",variant:"DLX",fuel_type:"Petrol", serial_no:"123" , purchase_price:"1234", selling_price: "12345", actions: "Edit/Delete" },
  ];
  
  export const keyMapping = {
    //"Sr No.": "srno",
    "Name":"name",
    "Product": "product_name",
    "Variant":"variant_name",    
    "Sub Product":"subproduct_name",
    "Make":"make_name",
    "Model":"model_name",
    "Accessory":"item_name",
    "Fuel":"fuel_type_name",
    "Serial No.":"serial_no",
    "Purchase Price":"purchase_price",

    "Action": [
        { type: "edit", icon: editIcon, label: "Edit" },
        
      ]
  };